export default __webpack_public_path__ + "static/media/koder.091bd76e.svg";